export function closestPreviousSibling (el: HTMLElement, selector: string) {
    let sibling = el.previousElementSibling
    if (!selector) return sibling

    while (sibling) {
        if (sibling.matches(selector)) return sibling
        sibling = sibling.previousElementSibling
    }
}
